module.exports = __webpack_public_path__ + "img/ic_logo_douyin@2x.755eda27.png";